var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"fill-height",attrs:{"tile":"","align":"top"}},[_c('v-container',[_c('v-container',_vm._l((8),function(i){return _c('div',{key:i},[_c('img',{attrs:{"width":"100%","src":'static/PrivacyPolicy/SpotSaver_privacy_policy-' + i + '.png'}})])}),0)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01c6e9ad","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/PrivacyPage.vue
// module id = null
// module chunks = 